import {
  Box,
  makeStyles,
  TextField,
  Typography,
  InputAdornment,
  SvgIcon
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { green } from '@material-ui/core/colors';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';

const Toolbar = ({ searchRef }) => {
  const classes = useStyles();
  const [query, setQuery] = useState({
    page: 1,
    page_size: PAGE_SIZE_LIST
  });

  const onEnterSearchInput = event => {
    if (!searchRef) return;
    if (event.keyCode === 13) {
      const queryValue = Object.assign({}, query, {
        keywords: event.target.value,
        page: 1
      });
      setQuery(queryValue);
      searchRef(queryValue);
    }
  };

  const changeTextInputSearch = event => {
    const queryValue = Object.assign({}, query, {
      keywords: event.target.value,
      page: 1
    });
    setQuery(queryValue);
  };

  return (
    <div className={classes.root}>
      <Box className={classes.groupSearch}>
        <div className={classes.groupSearchLeft}>
          <Typography
            style={{ fontSize: '24px', fontWeight: '600', color: '#0C1132' }}
          >
            Nhật ký hoạt động
          </Typography>
        </div>
        {/* <Box
          style={{
            marginLeft: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px'
          }}
        >
          <Box>
            <TextField
              onKeyDown={onEnterSearchInput}
              onChange={changeTextInputSearch}
              className={'searchInputDevice'}
              variant="outlined"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                ),
                style: {
                  fontSize: '14px',
                }
              }}
              placeholder="Tên hoặc số điện thoại"
            />
          </Box>
        </Box> */}
      </Box>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

const useStyles = makeStyles(theme => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 172
  },

  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  groupSearch: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // overflowX: 'scroll',
    minWidth: '50%'
  },
  groupSearchLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  searchInput: {
    width: '250px'
  },
  styleInputSearch: {
    height: '39px',
    textTransform: 'none',
    padding: '0px 1em'
  },
  exportBtn: {
    justifyContent: 'flex-end',
    display: 'flex',
    paddingTop: '10px',
    paddingBottom: '10px'
  },
  shadowBox: {
    boxShadow: '0 2px 5px rgba(0,0,0,.18)'
  }
}));

export default Toolbar;
